<template>
    <span>
        <button
            class="btn btn-md is-primary mb-md md:mb-0"
            :disabled="selectedStreamArticles.length < 1"
            @click="$modal.show('upgrade-stream-modal')"
        >
            {{ lang('Lägg till streamtillägg', 'Add stream addons') }}
        </button>

        <form-modal
            :title="lang('Lägg till streamtillägg', 'Add stream addons')"
            name="upgrade-stream-modal"
            method="post"
            :action="route('front.my-pages.api.streams.store')"
            :redirect-to="route('front.my-pages.tv.index')"
            :primary-button-text="lang('Lägg till streamtillägg', 'Add stream addons')"
            :close-button-text="lang('Avbryt','Cancel')"
        >
            <div v-for="stream in selectedStreamArticlesNotOwnedByCustomer">
                <input
                    type="hidden"
                    name="streams[]"
                    :value="stream.article_id"
                >
                <h2 class="font-bold text-md">
                    {{ stream.name }}
                </h2>
                <table class="table responsive-stack is-service mt-0">
                    <tbody>
                        <tr>
                            <th class="accordion-title-width">
                                {{ lang('Tjänst', 'Service') }}
                            </th>
                            <td>{{ stream.name }}</td>
                            <td />
                        </tr>
                        <tr>
                            <th>{{ lang('Månadskostnad', 'Monthly cost') }}</th>
                            <td>
                                <span
                                    v-if="streamIsIncluded(stream)"
                                    class="block text-sm mt-xs"
                                >
                                    {{ format_sek(0) }}
                                </span>

                                <span
                                    v-else
                                    class="block text-sm"
                                >
                                    {{ format_sek(stream.monthly_price) }}
                                </span>
                            </td>
                            <td />
                        </tr>
                        <tr>
                            <th>{{ lang('Bindningstid', 'Binding period') }}</th>
                            <td>Ingen bindningstid</td>
                            <td />
                        </tr>
                        <tr>
                            <th>{{ lang('Uppsägningstid', 'Termination time') }}</th>
                            <td>1 månad</td>
                            <td />
                        </tr>
                    </tbody>
                </table>
            </div>
        </form-modal>
    </span>
</template>

<script>
    import StreamMixin from '../../Shared/StreamMixin';

    export default {
        mixins: [StreamMixin],
        props: {
            selectedStreamArticles: {
                type: Array,
                required: true,
            },
        },
        computed: {
            selectedStreamArticlesNotOwnedByCustomer() {
                return this.selectedStreamArticles.filter(
                    streamArticle => ! streamArticle.owned_by_customer
                );
            },
        },
    };
</script>
